export function getPosition(el: HTMLElement) {
    return {
        top: el.offsetTop,
        left: el.offsetLeft,
    };
}
